import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
import { Check, X } from 'lucide-react';
export function DarkSections() {
  return <div className="bg-navy text-white" data-id="element-189" data-mp="1ibzz2fq70zv8">
      {/* RESULTADO */}
      <section className="py-24 border-b border-slate-800" data-id="element-190" data-mp="1ecr10yo4eftv">
        <div className="container mx-auto px-4" data-id="element-191" data-mp="19do6471utpzm">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-192" data-mp="19ez944nh6tpo">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight leading-tight" data-id="element-193" data-mp="1s3w6ihe662c4">
              Más información. Mejores decisiones.{' '}
              <span className="text-cyan" data-id="element-194" data-mp="lp50y0e3ptbr">Más licitaciones rentables.</span>
            </h2>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 max-w-6xl mx-auto" data-id="element-195" data-mp="gn5wsoajesdr">
            {[{
            value: '14k+',
            label: 'Riesgos detectados'
          }, {
            value: '2.5M',
            label: 'Documentos analizados'
          }, {
            value: '850k',
            label: 'Horas ahorradas'
          }, {
            value: '45k+',
            label: 'Consultas sugeridas'
          }, {
            value: '$1.2B',
            label: 'Potenciales impactos económicos'
          }].map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-900 border border-slate-800 rounded-xl p-6 text-center" data-id="element-196" data-mp="1uwoktg3kxjx" data-mpi={i}>
                <div className="text-3xl md:text-4xl font-bold text-cyan mb-2" data-id="element-197" data-mp="304ychplj09tx">
                  {stat.value}
                </div>
                <div className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-198" data-mp="2v6wrv08gc2gc">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* VENTAJA COMPETITIVA */}
      <section className="py-24 relative overflow-hidden" data-id="element-199" data-mp="3ivfzddjogb7d">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-techblue/10 blur-[120px] rounded-full pointer-events-none" data-id="element-200" data-mp="3ix960suaivfd" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-201" data-mp="27hu9fq5zu5ks">
          <div className="max-w-5xl mx-auto" data-id="element-202" data-mp="22gwurnk6zto1">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-203" data-mp="22jaont34yzu0">
              {/* Tradicional */}
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 opacity-80" data-id="element-204" data-mp="i0yrm2kwa3wr">
                <h3 className="text-xl font-semibold text-slate-400 mb-8 pb-4 border-b border-slate-800" data-id="element-205" data-mp="11ph9dz3kmf1f">
                  Método tradicional
                </h3>
                <ul className="space-y-6" data-id="element-206" data-mp="1aocibiy0238f">
                  {['cientos de PDFs', 'revisión manual', 'tiempo limitado', 'riesgo invisible'].map((item, i) => <li key={i} className="flex items-center gap-4 text-slate-500" data-id="element-207" data-mp="3hdr4qohqw2du" data-mpi={i}>
                      <div className="w-6 h-6 rounded-full bg-slate-800 flex items-center justify-center shrink-0" data-id="element-208" data-mp="1bo5mfny842ci">
                        <X size={14} className="text-risk/70" data-id="element-209" data-mp="16t9q4blyestl" />
                      </div>
                      <span className="text-lg" data-id="element-210" data-mp="1kokhhf0zovt7">{item}</span>
                    </li>)}
                </ul>
              </motion.div>

              {/* Prisma */}
              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-slate-800/40 border border-techblue/30 rounded-2xl p-8 relative shadow-[0_0_40px_-10px_rgba(37,99,235,0.2)]" data-id="element-211" data-mp="t00owy85tdm5">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-techblue to-cyan rounded-t-2xl" data-id="element-212" data-mp="5aptlw9kwbfe" />
                <h3 className="text-xl font-bold text-white mb-8 pb-4 border-b border-slate-700 flex items-center gap-2" data-id="element-213" data-mp="3ralsf4frn270">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-techblue to-cyan" data-id="element-214" data-mp="3w3ezhyypimm9">
                    Prisma
                  </span>
                </h3>
                <ul className="space-y-6" data-id="element-215" data-mp="3md2b1vnru9au">
                  {['análisis completo', 'riesgo visible', 'información conectada', 'inteligencia accionable'].map((item, i) => <motion.li key={i} initial={{
                  opacity: 0,
                  x: 10
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.2 + i * 0.1
                }} className="flex items-center gap-4 text-slate-200" data-id="element-216" data-mp="3z2vr82xk7t5" data-mpi={i}>
                      <div className="w-6 h-6 rounded-full bg-techblue/20 flex items-center justify-center shrink-0 border border-techblue/30" data-id="element-217" data-mp="qe1mun9l9xh4">
                        <Check size={14} className="text-cyan" data-id="element-218" data-mp="le5pv7zb76b2" />
                      </div>
                      <span className="text-lg font-medium" data-id="element-219" data-mp="gesws5huh301">{item}</span>
                    </motion.li>)}
                </ul>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="py-32 border-t border-slate-800 relative overflow-hidden" data-id="element-220" data-mp="2i5v5pey5ons">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20" data-id="element-221" data-mp="21ui4mn8m8q75" />

        <div className="container mx-auto px-4 relative z-10 text-center max-w-4xl" data-id="element-222" data-mp="29drc2axkaetk">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-223" data-mp="29belj9dqmw4w">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight leading-tight mb-6" data-id="element-224" data-mp="1lhd9pbfifp8s">
              Antes de comprometer millones, entiende exactamente qué estás
              licitando.
            </h2>
            <p className="text-xl text-slate-400 mb-10" data-id="element-225" data-mp="1vcory3q4nela">
              Descubre riesgos, oportunidades y requisitos ocultos antes de
              presentar tu oferta.
            </p>
            <Button size="lg" variant="solid" className="text-lg px-8 h-14" data-id="element-226" data-mp="36sn2kc0ye8om">
              Solicitar Demo
            </Button>
          </motion.div>
        </div>
      </section>
    </div>;
}